/* LOGIXA homepage content — DE (Leitsprache).
   Alle 9 Sprachdateien MÜSSEN dieselbe Form haben: `Content = typeof de`.
   Regel aus REDESIGN_SPEC.md §1: keine Zahl ohne Quelle. */

export const de = {
  nav: {
    links: [
      { label: 'Produkt', href: '#plattform' },
      { label: 'Lösungen', href: '#disposition' },
      { label: 'Integrationen', href: '#integrationen' },
      { label: 'Preise', href: '#preise' },
      { label: 'Ressourcen', href: '/docs' },
    ],
    login: 'Login',
    demo: 'Demo buchen',
    menu: 'Menü',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'TMS Software für Speditionen, die mehr als nur disponieren wollen.',
    sub: 'Aufträge, Disposition, Fahrer, Fuhrpark, GPS, Dokumente und Abrechnung in einer Plattform. LOGIXA verbindet Ihre gesamte Transportorganisation – vom Auftrag bis zur Abrechnung.',
    primary: 'Demo buchen',
    secondary: 'Live-Demo ansehen',
    trust: ['DSGVO-konform', 'Hosting in Deutschland', '9 Sprachen', 'In 12 Tagen startklar'],
    demoNote: 'Demonstrationsdaten',
  },

  mock: {
    search: 'Suche…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Übersicht', 'Aufträge', 'Disposition', 'Fahrzeuge', 'Fahrer', 'Tourenplanung', 'GPS Tracking', 'Dokumente', 'Nachrichten', 'Berichte', 'Abrechnung', 'Einstellungen'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Hamburg, DE → Rotterdam, NL',
      etaLbl: 'ETA',
      eta: 'Heute, 14:30',
      driverLbl: 'FAHRER',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Aktive Aufträge',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'IN TRANSIT', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'UNTERWEGS', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'BELADEN', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'GEPLANT', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'ABGESCHLOSSEN', tone: 'done' },
    ],
    kpiTitle: 'KPI Heute',
    kpis: [
      { lbl: 'AUFTRÄGE', val: '850', delta: '+14 %' },
      { lbl: 'LEERFAHRTEN', val: '14 %', delta: '−16 %' },
      { lbl: 'UMSATZ', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Fahrzeugstatus',
    status: [
      { n: '104', lbl: 'IN TRANSIT' },
      { n: '18', lbl: 'BELADEN' },
      { n: '7', lbl: 'ENTLADEN' },
      { n: '4', lbl: 'WARTUNG' },
      { n: '2', lbl: 'INAKTIV' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Integriert in Ihre bestehende\nLogistik-Infrastruktur',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'PLATTFORM',
    h2: 'Ihre Spedition. Ein System.',
    sub: 'Keine Excel-Listen. Keine getrennten Fahrer-, GPS- und Abrechnungssysteme. Keine Informationen zwischen fünf Tools suchen.',
    areas: [
      {
        n: '01',
        title: 'Aufträge & Disposition',
        desc: 'Aufträge erfassen, Fahrer und Fahrzeuge zuweisen, Touren planen und den Transportstatus in Echtzeit verfolgen.',
        chips: ['Aufträge', 'KI-Disposition', 'Tourenplanung', 'ePOD'],
      },
      {
        n: '02',
        title: 'Fuhrpark & GPS',
        desc: 'Fahrzeuge live verfolgen, Wartungen planen, TCO überwachen und Geofences verwalten.',
        chips: ['Live GPS', 'TCO', 'Wartung', 'Geofencing'],
      },
      {
        n: '03',
        title: 'Fahrer & Compliance',
        desc: 'Arbeitszeiten, Dokumente, Tachograph und EU-561-Regeln zentral überwachen – bevor Fristen zum Problem werden.',
        chips: ['Tachograph', 'EU 561', 'ADR', 'Modul 95'],
      },
      {
        n: '04',
        title: 'Abrechnung & Finanzen',
        desc: 'Löhne, Zuschläge, Auszahlungen und DATEV-Prozesse direkt mit den operativen Transportdaten verbinden.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Alle Funktionen entdecken',
  },

  dispatch: {
    kicker: 'INTELLIGENTE DISPOSITION',
    h2: 'Disposition, die mitdenkt.',
    sub: 'LOGIXA berücksichtigt Fahrer, Fahrzeuge, Lenkzeiten, Verfügbarkeit und Route und unterstützt Disponenten bei der optimalen Zuordnung.',
    points: [
      { title: 'KI-Disposition', desc: 'Fahrer und Fahrzeug passend zum Auftrag vorschlagen.' },
      { title: 'Tourenoptimierung', desc: 'Maut, Entfernung, Lenkzeiten und Kraftstoff berücksichtigen.' },
      { title: 'Diesel Intelligence', desc: 'Tankstopps anhand aktueller Kraftstoffpreise entlang der Route planen.' },
    ],
    panelTitle: 'Routenempfehlung',
    metrics: [
      { lbl: 'Entfernung', val: '1.346 km' },
      { lbl: 'Fahrzeit', val: '17 h 25 min' },
      { lbl: 'Maut', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1.245 kg' },
    ],
    stopsTitle: 'Empfohlene Tankstopps',
    live: 'LIVE',
    stops: [
      { city: 'Hannover', price: '€ 1,59', best: false },
      { city: 'Kassel', price: '€ 1,58', best: false },
      { city: 'Frankfurt', price: '€ 1,55', best: true },
      { city: 'Würzburg', price: '€ 1,62', best: false },
    ],
    apply: 'Route übernehmen',
    source: 'Preisquellen: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'FAHRER-APP',
    h2: 'Der Fahrer hat alles dabei.',
    sub: 'Native Apps für iOS und Android – der komplette Tourablauf vom Auftrag bis zur Unterschrift, auch ohne Netz.',
    flow: ['Auftrag erhalten', 'Navigation starten', 'Dokumente scannen', 'ePOD unterschreiben', 'Tour abschließen'],
    chips: ['iOS', 'Android', 'Offline-Modus', 'Telegram Bot', '9 Sprachen'],
    phones: [
      {
        tag: 'AUFTRAG #DE-1107',
        title: 'Hamburg → Rotterdam',
        rows: [
          { lbl: 'ABHOLUNG', val: 'Heute 08:30' },
          { lbl: 'ZUSTELLUNG', val: 'Heute 14:30' },
          { lbl: 'FAHRZEUG', val: 'HH-LOG 33' },
          { lbl: 'LADUNG', val: '18 Paletten · 12,4 t' },
        ],
        action: 'Navigation starten',
      },
      {
        tag: 'DOKUMENTE',
        title: 'CMR scannen',
        rows: [
          { lbl: 'FRACHTBRIEF', val: 'CMR-2026-4471' },
          { lbl: 'STATUS', val: 'Gescannt · 2 Seiten' },
          { lbl: 'ABLIEFERSCHEIN', val: 'Ausstehend' },
        ],
        action: 'Scan hochladen',
      },
      {
        tag: 'ePOD',
        title: 'Empfang bestätigen',
        rows: [
          { lbl: 'EMPFÄNGER', val: 'De Vries Logistics BV' },
          { lbl: 'UNTERSCHRIFT', val: 'Erfasst' },
          { lbl: 'FOTOS', val: '3 Anhänge' },
        ],
        action: 'Tour abschließen',
      },
    ],
  },

  compliance: {
    kicker: 'COMPLIANCE & SICHERHEIT',
    h2: 'Lenkzeiten sehen, bevor sie zum Problem werden.',
    sub: 'Lenk- und Ruhezeiten, Tachograph-Daten und ablaufende Dokumente an einer Stelle – mit Warnung, solange noch Zeit zum Reagieren ist.',
    points: [
      { title: 'EU 561', desc: 'Aktuelle Lenk- und Ruhezeiten je Fahrer, laufend abgeglichen.' },
      { title: 'Tachograph', desc: 'DDD-Dateien importieren und Fahrerdaten im Blick behalten.' },
      { title: 'Dokumente', desc: 'Warnungen vor Ablauf von Führerschein, ADR und Modul 95.' },
    ],
    dashDriverLbl: 'Fahrer',
    dashDriver: 'John D.',
    badge: 'KONFORM',
    bars: [
      { lbl: 'Lenkzeit heute', val: '7 h 45 / 9 h', pct: 86, tone: 'warn' },
      { lbl: 'Lenkzeit Woche', val: '38 h 10 / 56 h', pct: 68, tone: 'ok' },
      { lbl: 'Nächste Ruhezeit', val: 'in 1 h 15 min', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Ablaufende Dokumente',
    docs: [
      { lbl: 'Führerschein', val: '12.03.2027', warn: false },
      { lbl: 'ADR-Zertifikat', val: '18.05.2027', warn: true },
      { lbl: 'Modul 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 WARNUNGEN AKTIV',
  },

  onboarding: {
    kicker: 'UMSTIEG',
    h2: 'Noch Excel? Kein Problem.',
    sub: 'Wir übernehmen Fahrer, Fahrzeuge und Geschäftspartner aus Excel, CSV oder Ihrem bisherigen TMS.',
    promoTitle: 'In 12 Tagen startklar.',
    promoSub: 'Schnell. Sicher. Ohne Risiko.',
    promoCta: 'Demo buchen',
    steps: [
      { tag: 'TAG 1', title: 'Prozesse ansehen', desc: 'Demo und Analyse Ihrer Abläufe.' },
      { tag: 'TAG 2–4', title: 'Pilot starten', desc: 'Pilotbetrieb mit echten Fahrzeugen.' },
      { tag: 'TAG 5–8', title: 'Daten importieren', desc: 'Fahrer, Fahrzeuge und Stammdaten übernehmen.' },
      { tag: 'TAG 9–10', title: 'Team schulen', desc: 'Schulung Ihrer Disponenten und Fahrer.' },
      { tag: 'TAG 11–12', title: 'Live gehen', desc: 'Produktiv starten mit vollem Support.' },
    ],
  },

  roi: {
    kicker: 'EINSPARPOTENZIAL',
    h2: 'Was LOGIXA in Ihrer Flotte bewegt.',
    fields: [
      { lbl: 'Fahrzeuge', unit: '' },
      { lbl: 'Fahrer', unit: '' },
      { lbl: 'Aufträge pro Monat', unit: '' },
      { lbl: 'Ø km je Fahrzeug und Jahr', unit: 'km' },
    ],
    panelTitle: 'POTENZIAL PRO JAHR',
    lines: ['Weniger Verwaltungsaufwand', 'Optimierte Leerfahrten', 'Kraftstoffoptimierung'],
    totalLbl: 'Geschätztes Potenzial',
    basisLink: 'Berechnungsgrundlage anzeigen',
    basisClose: 'Berechnungsgrundlage ausblenden',
    basis: [
      'Verwaltungsaufwand: 7,50 € je Auftrag (rund 13 Minuten bei einem Personalkostensatz von 34 €/Std.) plus 15 € je Fahrer und Monat für Zeiterfassung und Lohnvorbereitung.',
      'Leerfahrten: 18 % Leerkilometeranteil, davon 5 % durch bessere Disposition vermeidbar, bei 1,04 € Kosten je Kilometer.',
      'Kraftstoff: 30 l Verbrauch je 100 km und 2 ct/l Ersparnis durch Tankstopp-Planung entlang der Route – berechnet aus den Live-Preisen von Tankerkönig (DE), prix-carburants (FR), E-Control (AT) und MITECO (ES).',
      'Alle Angaben sind eine Schätzung auf Basis branchenüblicher Annahmen und keine zugesicherte Einsparung.',
    ],
  },

  pricing: {
    kicker: 'PREISE',
    h2: 'Transparente Preise. Planbar. Fair.',
    sub: 'Wählen Sie den Tarif, der zu Ihrer Flotte passt. Monatlich kündbar.',
    allLink: 'Alle Preise ansehen',
    perMonth: '/ Monat',
    badge: 'EMPFOHLEN',
    cta: 'Demo buchen',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'bis 15 Fahrzeuge',
        features: ['Auftragsmanagement', 'Fahrer-App', 'GPS Tracking', 'E-Mail Support'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'bis 50 Fahrzeuge',
        features: ['Alle Starter-Funktionen', 'KI-Disposition', 'Tachograph & EU 561', 'Priority Support'],
      },
      {
        name: 'ENTERPRISE', price: 'Individuell', custom: true, scope: '50+ Fahrzeuge',
        features: ['Alle Business-Funktionen', 'Erweiterte Berechtigungen', 'API & Integrationen', 'Persönlicher Ansprechpartner'],
      },
    ],
    note: ['Kleinere Flotten starten günstiger: ', 'BASIC ab 49 €/Monat', ' für bis zu 3 Fahrzeuge, ', 'DRIVER kostenlos', ' für Selbstständige mit einem LKW.'],
  },

  security: {
    title: 'Ihre Daten bleiben in Europa.',
    items: ['Hosting in Deutschland', 'DSGVO-konform', '2FA & Passkeys', 'Audit Logs', 'Verschlüsselung at rest'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Häufige Fragen zu TMS-Software.',
    sub: 'Noch offene Punkte? Wir beantworten sie in der Demo.',
    list: [
      {
        q: 'Was ist eine TMS Software?',
        a: 'Ein Transport Management System bündelt Auftragsabwicklung, Disposition, Fahrzeug- und Fahrerverwaltung, Dokumente und Abrechnung in einer Plattform – statt in getrennten Excel-Listen, GPS-Portalen und Buchhaltungstools.',
      },
      {
        q: 'Für welche Speditionen eignet sich LOGIXA?',
        a: 'Für Speditionen und Transportunternehmen von 3 bis über 50 Fahrzeugen. Selbstständige mit einem LKW starten im kostenlosen DRIVER-Tarif, kleine Flotten mit BASIC ab 49 €/Monat, mittelständische Betriebe mit STARTER oder BUSINESS.',
      },
      {
        q: 'Kann LOGIXA Excel ersetzen?',
        a: 'Ja. Aufträge, Fahrer, Fahrzeuge, Stammdaten und Abrechnung liegen in einer Datenbank statt in verteilten Tabellen. Bestehende Excel- und CSV-Dateien übernehmen wir beim Umstieg – Sie starten mit Ihren eigenen Daten.',
      },
      {
        q: 'Wie lange dauert die Einführung?',
        a: 'Wir planen den Umstieg in 12 Tagen: Prozessanalyse, Pilotbetrieb mit echten Fahrzeugen, Datenimport, Schulung und Livegang. Der Zeitplan ist unser Vorgehen, nicht ein Durchschnittswert aus Kundenprojekten.',
      },
      {
        q: 'Kann ich mein bestehendes GPS weiterverwenden?',
        a: 'In vielen Fällen ja. LOGIXA erfasst Positionen über die Fahrer-App ohne zusätzliche Hardware und kann daneben Telematik-Daten aus vorhandenen Systemen übernehmen. Welche Anbindung in Ihrem Fall möglich ist, klären wir vor dem Start.',
      },
      {
        q: 'Unterstützt LOGIXA Tachograph und EU-561?',
        a: 'Lenk- und Ruhezeiten nach EU 561 werden je Fahrer laufend ausgewertet, inklusive Warnungen vor Überschreitungen. DDD-Dateien aus dem Tachograph lassen sich importieren und einsehen; als amtliche Fahrtenschreiber-Auswertung gegenüber Behörden ist die Auswertung nicht gedacht.',
      },
      {
        q: 'Gibt es eine Fahrer-App?',
        a: 'Ja, native Apps für iOS und Android in neun Sprachen: Auftrag, Navigation, Dokumentenscan, ePOD-Unterschrift und Tourabschluss – auch offline. Zusätzlich gibt es einen Telegram-Bot für Fahrer ohne installierte App.',
      },
      {
        q: 'Kann LOGIXA mit TIMOCOM und Trans.eu verbunden werden?',
        a: 'Die Anbindungen sind vorbereitet und gegen die dokumentierten Schnittstellen entwickelt. Die Freischaltung läuft über Ihren eigenen TIMOCOM- bzw. Trans.eu-Vertrag; im Rahmen der Einführung richten wir die Verbindung gemeinsam ein und testen sie mit Ihren Zugangsdaten.',
      },
      {
        q: 'Wo werden die Daten gespeichert?',
        a: 'Auf Servern in Deutschland, DSGVO-konform, verschlüsselt im Transport und im Ruhezustand. Zugriffe werden protokolliert, Anmeldungen lassen sich mit 2FA und Passkeys absichern.',
      },
      {
        q: 'Was kostet LOGIXA?',
        a: 'DRIVER ist kostenlos für Selbstständige mit einem LKW, BASIC beginnt bei 49 €/Monat für bis zu 3 Fahrzeuge, STARTER kostet 199 €/Monat bis 15 Fahrzeuge, BUSINESS 499 €/Monat bis 50 Fahrzeuge. Ab 50 Fahrzeugen rechnen wir individuell ab. Alle Tarife sind monatlich kündbar.',
      },
    ],
  },

  finalCta: {
    h2: 'Sehen Sie LOGIXA mit Ihren eigenen Transportprozessen.',
    sub: 'In einer 30-minütigen Demo zeigen wir Ihnen genau die Module, die für Ihre Flotte relevant sind.',
    primary: 'Demo buchen',
    secondary: 'Live-Demo ansehen',
  },

  footer: {
    tagline: 'TMS Software für Speditionen und Transportunternehmen in Europa.',
    cols: [
      {
        title: 'PRODUKT',
        links: [
          { label: 'Funktionen', href: '/platform/funktionen' },
          { label: 'KI-Disposition', href: '/platform/ki' },
          { label: 'Fahrer-App', href: '/platform/funktionen#apps' },
          { label: 'Tourenplanung', href: '/platform/funktionen#tourenplanung' },
          { label: 'Abrechnung', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'LÖSUNGEN',
        links: [
          { label: 'Kleine Speditionen', href: '/pricing' },
          { label: 'Mittelständische Flotten', href: '/pricing' },
          { label: 'Fernverkehr', href: '/platform/funktionen' },
          { label: 'Selbstständige Fahrer', href: '/pricing' },
        ],
      },
      {
        title: 'INTEGRATIONEN',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Alle Integrationen', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'RESSOURCEN',
        links: [
          { label: 'Wissen', href: '/docs' },
          { label: 'Blog', href: '/blog' },
          { label: 'Was ist ein TMS?', href: '/docs' },
          { label: 'TMS-Kosten', href: '/pricing' },
          { label: 'Hilfecenter', href: '/docs' },
        ],
      },
      {
        title: 'UNTERNEHMEN',
        links: [
          { label: 'Über uns', href: '/about' },
          { label: 'Karriere', href: '/jobs' },
          { label: 'Partner', href: '/companies' },
          { label: 'Kontakt', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Alle Rechte vorbehalten.',
    legal: [
      { label: 'Datenschutz', href: '/datenschutz' },
      { label: 'Impressum', href: '/impressum' },
      { label: 'AGB', href: '/agb' },
      { label: 'Sicherheit', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
